/** "I miei attestati": uno per ogni webinar con il test superato, con codice di verifica e download. */
import { formattaCodice, formattaMinuti } from '@aulaviva/shared';
import { Alert, Button, CertificateCard, EmptyState, PageHeading } from '@aulaviva/ui';
import { Award } from 'lucide-react';
import { Link } from 'react-router';
import { useMieiAttestati } from '@/api/documenti';
import { formattaData } from '@/lib/date';
import { comuni, documenti } from '@/testi';

export function Attestati() {
  const t = documenti.attestati;
  const attestati = useMieiAttestati();
  return (
    <>
      <PageHeading subtitle={t.sottotitolo}>{t.titolo}</PageHeading>
      {attestati.isPending && <p className="t-body text-ink-muted">{comuni.caricamento}</p>}
      {attestati.isError && <Alert variant="error" title={attestati.error.message} action={<Button onClick={() => attestati.refetch()}>{comuni.riprova}</Button>} />}
      {attestati.data && attestati.data.length === 0 && (
        <EmptyState icon={Award} title={t.nessunoTitolo}>
          {t.nessunoTesto}
        </EmptyState>
      )}
      {attestati.data && attestati.data.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {attestati.data.map((a, i) => (
            <CertificateCard
              key={a.id}
              titolo={a.webinarTitolo}
              data={formattaData(a.dataWebinar)}
              presenza={t.presenza(formattaMinuti(a.minutiTotali), Math.floor(a.percentuale))}
              codice={formattaCodice(a.codice)}
              stato={a.revocatoAt ? 'revocato' : a.stato}
              url={a.url}
              emesso={a.emessoAt ? t.emessoIl(formattaData(a.emessoAt)) : null}
              // il primo attestato pronto è l'azione principale della pagina; gli altri restano secondari
              variantePrimaria={i === attestati.data.findIndex((x) => x.stato === 'pronto' && !x.revocatoAt && x.url)}
              testi={t}
            />
          ))}
        </div>
      )}
      <p className="t-body-small text-ink-muted">
        <Link to="/verifica" className="t-label">
          {t.verificaLink}
        </Link>
      </p>
    </>
  );
}
